import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

export type RepTop30State = {
  selectedRep: { id: string; name: string } | null;
};

const initialState: RepTop30State = {
  selectedRep: null,
};

export const repTop30Slice = createSlice({
  name: "repTop30",
  initialState,
  reducers: {
    setSelectedRep: (
      state,
      { payload }: PayloadAction<{ id: string; name: string } | null>
    ) => {
      state.selectedRep = payload;
    },
    resetRepTop30: () => initialState,
  },
});

export const { setSelectedRep, resetRepTop30 } = repTop30Slice.actions;
export default repTop30Slice.reducer;
